import styled from 'styled-components';
import DetailCancelledSvg from '../../assets/mytrips/hotel-detail-cancelled.svg';

const DetailCancelledIcon = styled(DetailCancelledSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '46.5rem'};
  height: ${props => props.height || '14.1rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DetailCancelledIcon;
